import { Button } from '@material-ui/core'
import i18n from '../../../translations/i18n'

import { MuiClasses } from '../../../types'

interface BackButtonProps {
  classes?: MuiClasses
  doStepBack: () => void
  currentStep: number
}

export const BackButton = ({
  classes,
  doStepBack,
  currentStep
}: BackButtonProps) => {
  return (
    <Button
      disabled={currentStep === 0}
      onClick={doStepBack}
      style={{ width: '100%', height: '42px' }}
    >
      {i18n.t('general.back')}
    </Button>
  )
}
